import { SaleHorse } from '../sales/sale-horse.model';
import { Sale } from '../sales/sales.model';
import { StudyStatus } from '../status/status.model';
import { StudyFile } from './study-file.model';

export class SaleHorseStudyBase {
  saleId: number;
  horseId: number;
  studyFiles: StudyFile[];
  sale: Sale;
  isCompleteXrayTemplate: boolean;
  saleHorseStudies: Study[];
  saleHorse: SaleHorse;
  studyStatus: StudyStatus;
  //extra
  isSalesCompany: boolean;
  patientName?: string;
}

export class Study extends SaleHorseStudyBase {
  studyId: number;
  studyInstanceUID: string;
  sOPInstanceUID: string;
  sOPClassUID: string;
  studyDate: string;
  studyTime: string;
  dicomStudyId: string;
  referringPhysicianName: string;
  physiciansOfRecord: string;
  performingPhysicianName: string;
  accessionNumber: string;
  studyDescription: string;
  institutionName: string;
  institutionAddress: string;
  dicomPatientId: string;
  memberId: number;
  createdBy: number;
  createdDate: string;
  isActive: boolean;

  // New
  imageCount: number;
  microchip: string;
  modality: string;
  owner: string;

  studyDateTime?: Date;
  isAfterAllowedSubmissionDate: boolean;
  patientAge: string;
  responsiblePerson: string;
  viewerGuid: string;
  description: string;
  microchipNumber: string;
  isAllowDelete: boolean;
}

export class SearchFields {
  consignorName: string;
  accessionNumber: string;
  institutionName: string;
  studyDescription: string;
}

export enum SortTypes {
  ALL = 'all',
  TODAY = 'today',
  LAST_SEVEN_DAYS = 'last-seven-days',
  LAST_THIRTY_DAYS = 'last-thirty-days',
}

export enum StudyTableFields {
  STUDY_ID = 'studyId',
  OWNER = 'ownerName',
  STUDY_DATE = 'studyDate',
  CREATED_DATE = 'createdDateUtc',
  INSTITUTION_NAME = 'institutionName',
  MODALITY = 'modality',
  IMAGE_COUNT = 'imageCount',
  MEDIA_COUNT = 'mediaCount',
  REPORT_COUNT = 'reportCount',
  ACCESSION_NUMBER = 'accessionNumber',
  STUDY_DESCRIPTION = 'studyDescription',
  SALE_NAME = 'saleName',
  PATIENT_NAME = 'patientName',
  CONSIGNOR_NAME = 'consignorName',
  STATUS_NAME = 'statusName',
}

export class StudyDicomInfo {
  horse: SaleHorse;
  type: string;
  isAfterAllowedSubmissionDate: boolean;
}

export class StudyListItem {
  studyId: number;
  saleId!: number;
  horseId!: number;
  memberId: number;
  patientName: string;
  consignorName: string;
  ownerName: string;
  studyDescription: string;
  studyDate: Date;
  createdDateUtc: Date;
  institutionName: string;
  imageCount: number;
  mediaCount: number;
  reportCount: number;
  modality: string;
  accessionNumber: string;
  statusId: number;
  statusName: string;
  viewerGuid: string;
  performingPhysicianName: string;
  studyDateTime: string;
  isActive: boolean;
  microchipNumber: string;
}

export class DownloadStudyFileDto {
  studyFileId: number;
  originalFileName: string;
  azureFileName: string;
  displayFileName: string;
  createdBy: number;
  createdByName?: string;
  memberId: number;
  memberName?: string;
  createdDate: Date;
  studyFileSizeInMB?: number;
  isAvailableLocal: any;
  isInProgress: any;
  lot?: string;
  lotNumber?: number;
  lotNumberSuffix?: string;
  microchip?: string;
  horseName?: string;
  dam?: string;
  sire?: string;
  studyFileMimeTypeId?: any;
}

export class StudyFileDownloadStatusQueue {
  queueId: number;
  isInProgress: boolean;
  isCompleted: boolean;
  isCancelled: boolean;
  downloadStatus?: StudyFileDownloadStatusDto[];
}

export class StudyFileDownloadStatusDto {
  studyFileId: number;
  isInProgress: boolean;
  isCompleted: boolean;
}

export class StudyFileDownloadDetailDto {
  queueId: number;
  pendingStudyFileIds: number[];
  downloadedStudyFileIds: number[];
}

export class MediaEncoderAcknowledgmentMessageDto {
  isSuccess: boolean;
  message?: string;
  mediaFileName?: string;
}

export interface StudyDraftSubmissionAcknowledgementsDto {
  isLotHasXrayImagesSubmitted: boolean;
  isLotHasScopeVideoSubmitted: boolean;
  isStudyUploadedToDifferentLot: boolean;
}

export interface StudyDraftSubmissionAcknowledgementsRequestDto {
  isLotHasXrayImagesSubmittedAcknowledged: boolean;
  isLotHasScopeVideoSubmittedAcknowledged: boolean;
  isStudyUploadedToDifferentLotAcknowledged: boolean;
}

export interface HorseStudyDto {
  accessionNumber?: string;
  microchipNumber?: string;
  horseName?: string;
  age?: string;
  studyDate?: string;
  studyTime?: string;
  studyDateTime?: Date; // In C# it's computed, in TS you can compute it in service/helper
  consignor?: string;
}

export interface HorseStudyAcknowledgmentsDto {
  horseStudies?: HorseStudyDto[];
  draftAcknowledgments?: StudyDraftSubmissionAcknowledgementsDto;
  mediaConversionErrors?: MediaEncoderAcknowledgmentMessageDto[];
}
